export const defaultTermData = {
    termYear: null,
    termNumber: null,
    termName: '',
    comments: '',
    isCurrent: false,
    dateStart: null,
    dateEnd: null,
    createdBy: '',
}
